const { origin } = window.location;

export const routes = {
  main: `${origin}/`,
  policyDetails: (policyNumber: string) => `${origin}/policy/${policyNumber}`,
  policyPaymentMethod: (policyNumber: string) => `${origin}/policy/${policyNumber}/payment-method`,
  settings: (success?: boolean) =>
    `${origin}/settings${success ? "?success=true" : ""}`,
  editName: `${origin}/settings/name`,
  editMailingAddress: `${origin}/settings/address`,
  editPhoneNumber: `${origin}/settings/phone`,
  go: (route: string) => window.location.assign(route),
  documentDelivery: `${origin}/settings/document-delivery`,
};
